import type { NetState } from '../../net/GameClient'
import type { AuthStatus } from '../session'

/** The connection line under the Race button (the old menu's wording, T1.8). */
export function statusLine(auth: AuthStatus, net: NetState): string {
  if (auth === 'pending') return 'Signing in…'
  if (net.status === 'connecting') return 'Connecting…'
  if (net.status === 'offline') return 'Offline, retrying…'
  return auth === 'online' ? 'Ready to race' : 'Ready (guest without sign-in)'
}
